// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host {\n  display: block;\n}\n\n.toggle {\n  display: block;\n  max-width: 160px;\n  margin: var(--magic-space--large, 32px) auto 0;\n}", ""]);
// Exports
module.exports = exports;
